export const DisplayClasses = {
  NONE: ['wf-hidden'],
  BLOCK: ['wf-block'],
  FLEX: ['wf-flex'],
  INLINE: ['wf-inline'],
  INLINE_BLOCK: ['wf-inline-block']
}
